import React, { memo } from "react";
import { filterComparableData } from "../../utils/comparison";
import { Resizable } from "re-resizable";

const ImageData = ({ elData, handleOnStyleChange, keyVal }) => (
  elData.imgSrc ? (
    <Resizable
      className="imageData"
      onMouseDown={(e) => {
        if (e.target.style.cursor && e.target.style.cursor.includes("resize")) {
          e.preventDefault();
        }
      }}
      minHeight={10}
      maxHeight={260}
      enable={{ top: true, bottom: true }}
      defaultSize={{
        width: "100%",
        height: elData.styles.height || 200,
      }}
      onResizeStop={(_e, _dir, ref) => handleOnStyleChange(ref.clientHeight, keyVal)}
    >
      <a
        href={elData.url.value}
        target="_blank"
        onClick={elData.url.isValid ? null : (e) => e.preventDefault()}
        rel="noopener noreferrer"
        draggable={false}
      >
        <img src={elData.imgSrc} alt="img" draggable={false} />
      </a>
    </Resizable>
  ) : (
    <div className="imageData">
      <div className="imageData-initialView">Choose image from assets</div>
    </div>
  )
);

export default memo(ImageData, filterComparableData);
